// @flow
import React from 'react';
import DataTable from 'react-data-table-component';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import * as XLSX from 'xlsx';
import { formatToIndianSystem } from 'utils/formatToIndianSystem';
import { formatUnixTimestamp } from 'utils/dateFormat';
import download from '../../../assets/download.png';

function allMachines({ data }) {
  const columns = [
    {
      name: 'Vehicle Number',
      selector: (row) => row.vehicleNumber,
    },
    {
      name: 'Crusher Name',
      selector: (row) => row.customer,
    },
    {
      name: 'Auction Reference Number',
      selector: (row) => row.auctionReferenceNumber,
    },
    {
      name: 'Lot Number',
      selector: (row) => row.pitNumber,
    },
    {
      name: 'Weighbridge Number from where vehicle entered',
      selector: (row) => row.weighBridgeNumber,
    },
    {
      name: 'Material Dispatched (in MT)',
      selector: (row) => formatToIndianSystem(row.materialDispatched),
    },
    {
      name: 'Price of the material dispatched (in Rupee)',
      selector: (row) => formatToIndianSystem(row.priceOfMaterial),
    },
    {
      name: 'Mine Area Entry Date and Time',
      selector: (row) => {
        return formatUnixTimestamp(row.loggedInTime);
      },
    },
    {
      name: 'Pit Entry Date and Time',
      selector: (row) => {
        if (row.guardCheckIn > 0) {
          return formatUnixTimestamp(row.guardCheckIn);
        }
        return '-';
      },
    },
    {
      name: 'Pit Exit Date and Time',
      selector: (row) => {
        if (row.guardCheckOut > 0) {
          return formatUnixTimestamp(row.guardCheckOut);
        }
        return '-';
      },
    },
    {
      name: 'Mine Area Exit Date and Time',
      selector: (row) => {
        if (row.loggedOutTime > 0) {
          return formatUnixTimestamp(row.loggedOutTime);
        }
        return '-';
      },
    },
  ];

  const exportToExcel = () => {
    if (!data || data.length === 0) {
      return;
    }
    // Convert data to worksheet format
    const ws = XLSX.utils.json_to_sheet(
      data.map((row) => ({
        'Vehicle Number': row.vehicleNumber,
        'Crusher Name': row.cardNumber,
        'Auction Reference Number': row.auctionReferenceNumber,
        'Lot Number': row.pitNumber,
        'Weighbridge Number': row.weighBridgeNumber,
        'Material Dispatched (MT)': row.materialDispatched,
        'Price (₹)': row.priceOfMaterial,
        'Mine Entry Time': row.loggedInTime > 0 ? formatUnixTimestamp(row.loggedInTime) : '-',
        'Pit Entry Time': row.guardCheckIn > 0 ? formatUnixTimestamp(row.guardCheckIn) : '-',
        'Pit Exit Time': row.guardCheckOut > 0 ? formatUnixTimestamp(row.guardCheckOut) : '-',
        'Mine Exit Time': row.loggedOutTime > 0 ? formatUnixTimestamp(row.loggedOutTime) : '-',
      })),
    );

    // Create workbook and add worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Report');

    // Generate Excel file and trigger download
    XLSX.writeFile(wb, `report_${new Date().toISOString().split('T')[0]}.xlsx`);
  };

  return (
    <Card>
      <CardContent>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          Reports
        </Typography>
        <Button
          variant="contained"
          style={{
            float: 'right',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            backgroundColor: '#ffffff',
            color: '#666666', // Lighter shade of black
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
            fontSize: '10px', // Smaller text size
            fontWeight: '500', // Medium weight for better readability
            padding: '6px 12px', // Adjusted padding for smaller button
            '&:hover': {
              backgroundColor: '#f5f5f5',
            },
          }}
          onClick={exportToExcel}
        >
          <img
            src={download}
            alt="download"
            style={{
              width: '20px', // Control icon size
              height: '20px',
            }}
          />
          Export to Excel
        </Button>
        <div className="table-responsive">
          <DataTable columns={columns} data={data} pagination persistTableHead />
        </div>
      </CardContent>
    </Card>
  );
}

export default allMachines;
